import { render } from "./BaseRow.vue?vue&type=template&id=a0b952d8"
import script from "./BaseRow.vue?vue&type=script&lang=js"
export * from "./BaseRow.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__